import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Suspense, useEffect, useRef } from 'react'
import { AgentLoadingFallback } from '../components/common'
import { useAuth } from '../context/auth/useAuth'
import { createAgentLoader } from '../utils/createAgentLoader'
import { setFavicon } from '../utils/setFavicon'
import { setPageTitle } from '../utils/setPageTitle'

const Iris = createAgentLoader('iris', () => import('iris/app'))

export const Route = createFileRoute('/iris/$')({
  component: IrisPage,
})

function IrisPage() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const hasCheckedInitialAuth = useRef(false)

  // useReloadOnBack()

  setFavicon('/assets/iris-dark-isotipo.png')
  setPageTitle('Iris - Sofka Agents')

  // Solo verificar autenticación en el montaje inicial (ej: refresco de página)
  useEffect(() => {
    if (!hasCheckedInitialAuth.current) {
      hasCheckedInitialAuth.current = true
      if (!user) {
        navigate({ to: '/login' })
      }
    }
  }, [user, navigate])

  // Si no hay usuario en el primer render, mostrar loading mientras redirige
  if (!user && !hasCheckedInitialAuth.current) {
    return <AgentLoadingFallback />
  }

  return (
    <Suspense fallback={<AgentLoadingFallback />}>
      <Iris />
    </Suspense>
  )
}
